import { DatePicker } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Authorization from "../../../../component/Authorization";
import { DebounceSelect } from "../../../../component/DebounceSelect";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { IoPagination } from "../../../../helper/pagination";
import { UserUI } from "../../user/entity/user.model";
import { RouteContext } from "../../user/screen/components/route.context";
import { userService } from "../../user/service/user.service";
import { Assignment, AssignmentFilter } from "../entity/task.model";
import { taskService } from "../service/task.service";
import AssignmentTable from "./component/AssignmentTable";

function Assignments() {
  const { state } = useContext(RouteContext);
  const { dispatch } = useContext(SpinContext);
  let navigate = useNavigate();
  const [assignmentFilter, setAssignmentFilter] = useState<AssignmentFilter>({
    page: 1,
    pageSize: 10,
  });

  const [assignmentPagination, setAssignmentPagination] = useState<
    IoPagination<Assignment>
  >({
    totalElements: 1,
    content: [],
  });

  useEffect(() => {
    pageChange(assignmentFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.routeId]);

  const pageChange = (assignmentFilter: AssignmentFilter) => {
    dispatch({ type: spinActions.BLOCK });

    if (state.routeId.length > 0) {
      assignmentFilter.routeId = state.routeId;
    } else {
      assignmentFilter.routeId = undefined;
    }

    taskService
      .getAssignments(assignmentFilter)
      .then((pagination: IoPagination<Assignment>) => {
        assignmentPagination.current = assignmentFilter.page;
        setAssignmentPagination(pagination);
        dispatch({ type: spinActions.UNBLOCK });
      })
      .catch(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });
  };

  return (
    <>
      <MPageHeader crumbs={["Оноосон ажлууд"]} />
      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h6 className="card-title">Оноосон ажил</h6>

            <Authorization roles={["task-full"]}>
              <div className="header-elements">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => navigate("/assignments/add")}
                >
                  <i className="icon-plus2 pr-1"></i>
                  Оноосон ажил үүсгэх
                </button>
              </div>
            </Authorization>
          </div>
          <div className="card-body">
            <div className="d-flex bd-highlight example-parent mb-2">
              <DebounceSelect<UserUI>
                showSearch
                allowClear
                placeholder="Хайх"
                onChange={(value) => {
                  setAssignmentFilter({
                    ...assignmentFilter,
                    username: value?.username,
                  });
                }}
                fetchOptions={(search) => {
                  return userService.getUsers(search, state.routeId);
                }}
                style={{ maxWidth: "calc(100% - 91px)", width: "250px" }}
              />

              <DatePicker
                className="ml-2"
                placeholder="Огноо"
                onChange={(date, dateString) => {
                  setAssignmentFilter({
                    ...assignmentFilter,
                    date: dateString,
                  });
                }}
                style={{ width: 200 }}
              />
              <button
                type="button"
                className="btn btn-sm btn-primary ml-2"
                onClick={() => {
                  let _assignmentFilter = {
                    ...assignmentFilter,
                    page: 1,
                    pageSize: 10,
                  };

                  pageChange(_assignmentFilter);
                }}
              >
                <i className="icon-search4 mr-2" />
                Хайх
              </button>
            </div>

            <AssignmentTable
              pagination={assignmentPagination}
              onChange={(page: number, pageSize: number) => {
                pageChange({ page, pageSize });
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Assignments;
